import { Box, Typography } from '@mui/material';
import { Rating } from '@care/react-component-lib';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';
import { useResponsive } from '@/components/hooks/useResponsive';

export interface CaregiverRatingProps {
  avgReviewRating: NonNullable<Caregiver['avgReviewRating']>;
  numberOfReviews: number;
}

export const CaregiverRating = ({ avgReviewRating, numberOfReviews }: CaregiverRatingProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Box display="flex" alignItems="center">
      <Typography variant={isSmallViewport ? 'h5' : 'h4'} component="span" mr={0.5}>
        {avgReviewRating.toFixed(1)}
      </Typography>
      <Rating name="size-medium" size="medium" defaultValue={avgReviewRating} readOnly />
      <Typography variant={isSmallViewport ? 'body3' : 'body2'} component="span">
        ({numberOfReviews})
      </Typography>
    </Box>
  );
};
